import { StatsContextInterface } from '../../../stats/context.interface';
import { Snowplow2StatsSchemaAuthContextInterface } from '../schema/auth-context.interface';
import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { DataKeyValueStringInterface } from '../../../data/key-value/string.interface';
import { AuthenticationProviderType } from '../types';

export class Snowplow2StatsAdapterSchemaAuthContext implements StatsAdapterInterface {
  /**
   * Mapping of AuthenticationProviderType to snowplow2 authentication providers
   */
  private providerMapping: DataKeyValueStringInterface = {
    Facebook: 'facebook',
    Google: 'google',
    Email: 'pf',
  };

  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): Snowplow2StatsSchemaAuthContextInterface {
    const user = this.context.global.authentication.user;

    const schema: Snowplow2StatsSchemaAuthContextInterface = {
      schema: 'iglu:ae.propertyfinder/auth_context/jsonschema/1-0-0',
      data: {
        idp: <AuthenticationProviderType>this.providerMapping[this.context.global.authentication.provider] || 'pf',
        idp_id: String(user.id),
        pf_id: String(user.id),
      },
    };

    return schema;
  }
}
